@if ((lineItemOptions$ | async).length === 0) {
  <div class="flex flex-col items-center justify-center h-20">
    <span class="font-bold">No available Line Items.</span>
    <span class="font-bold">Make sure line items are present in the prime contract. (As non markup line item)</span>
  </div>
}

<app-dropdown
  [required]="true"
  [optionLabel]="null"
  [optionValue]="'id'"
  [ngModel]="lineItem.id"
  (ngModelChange)="lineItemChange($event)"
  [placeholder]="'Line Item' + entryIndex"
  [label]="'Line Item ' + entryIndex"
  [name]="'line_item_' + tempUUID"
  class="w-full"
  [options]="lineItemOptions$ | async"
>
  <ng-template #selectedContent #optionContent let-option>
    <div [ngClass]="{ 'disabled p-disabled': lineItemGroupIds().includes(option.id) }" class="flex flex-col">
      <div class="capitalize text-navy-900 text-medium">{{ option.name }}</div>
      <div class="capitalize text-navy-900 font-normal">{{ option?.division }} {{ option?.cost_type }}</div>
    </div>
  </ng-template>
</app-dropdown>

@for (description of lineItem.descriptions; track index; let index = $index) {
  @let descriptionIndex = index + 1;
  <div class="flex gap-2 w-full items-center">
    <div class="flex flex-1 gap-2">
      <app-floating-input
        [required]="true"
        class="flex-1"
        [ngModel]="description.spend_description"
        (ngModelChange)="descriptionChange($event, index)"
        [name]="'description_' + entryIndex + '_' + descriptionIndex"
        [label]="'Change Description ' + descriptionIndex"
        [placeholder]="'Change Description ' + descriptionIndex"
      ></app-floating-input>

      <app-floating-input
        [required]="false"
        class="flex-1"
        [ngModel]="description.budget_dollars"
        type="money"
        (ngModelChange)="budgetDollarsChange($event, index)"
        [name]="'budget_dollars_' + entryIndex + '_' + descriptionIndex"
        [label]="'Estimated Dollars'"
        [placeholder]="'Estimated Dollars'"
      ></app-floating-input>
    </div>

    <app-add-remove-buttons
      class="mt-3.5"
      (removeItem)="removeDescription(descriptionIndex)"
      (addItem)="addDescription(descriptionIndex)"
    >
    </app-add-remove-buttons>
  </div>
}
